import TagManager from 'react-gtm-module';
import GtmCommon from './gtmCommon';
import * as _ from 'lodash';
import { getStore } from '../store';
import { formatEmail } from './utils.service';

const GRANITE_LIST_SUBTEMPLATE_BY_TYPE = {
  monument: 'monument - liste granits',
  accessory: 'accessoire - liste granits',
  veneer: 'placage - liste granits',
  frame: 'semelle - liste granits'
};

const typeMonuments =[
  {title:"Inhumation",type:"interment"},
  {title:"Crémation",type:"cremation"},
  {title:"Mixte",type:"mixed"}
];

class GtmPro extends GtmCommon {
  constructor() {
    super("pro", "GTM-MNDPDK4")
    this.currentPage = {
      template: "configurateur",
      subtemplate: "Monuments"
    }
    this.product = null
  }
  setCurrentPage({subtemplate }) {
    this.currentPage = {
      template: "configurateur",
      subtemplate: subtemplate ?? this.currentPage.subtemplate
    };
  }

  setProduct(product) {
    this.product = product;
  }

  getCurrentPage() {
    return this.currentPage;
  }

  getProduct() {
    return this.product;
  }

  static getInstance() {
    if (!this.instance) {
      this.instance = new GtmPro();
    }
    return this.instance
  }

  isBrowser() {
    return typeof window !== 'undefined';
  }

  push(data) {
    if (!this.isBrowser()) return;

    window.dataLayer = window.dataLayer || [];
    TagManager.dataLayer({ dataLayer: data });

    // DEV debug (optional)
    if (process.env.NODE_ENV === 'development') {
      console.log('[GTM]', data);
    }
  }

  getUser() {
    const user = getStore().getState().user;
    if (!user) return {id: "", logged: false};

    return {
      id: user.id ? user.id : "undefined",
      email: user.identity.email ? formatEmail(user.identity.email) : "",
      firstname: user.identity.firstname ? user.identity.firstname : "undefined",
      lastname: user.identity.lastname ? user.identity.lastname : "undefined",
      logged: true,
    };
  }

  getPartner() {
    const identity = getStore().getState().user.identity;
    return identity?.organization?.reference || "undefined";
  }

  toDecimal(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  getProjectStatus(configuration = {}) {
    const status = configuration.status || {};

    if (status.validatedAt) return "commandé";
    if (status.prevalidatedAt) return "précommandé";
    if (status.completedAt) return "devis demandé";

    return "ouvert";
  }

  getProjectType(configuration = {}) {
    const isFamily = configuration.configType === "family" ||
      (this.isBrowser() && window.location.pathname.includes("/famille/"));

    if (isFamily) return "famille";
    if (configuration.quoteId || (this.isBrowser() && window.location.pathname.includes("/quote_variant/"))) {
      return "variante";
    }

    return "configuration";
  }

  getProjectReferences(configuration = {}) {
    const refs = [
      configuration.reference,
      _.get(configuration, "monument.reference"),
      _.get(configuration, "monument.headstone.reference"),
      _.get(configuration, "monument.footstone.reference"),
      _.get(configuration, "frame.reference"),
      _.get(configuration, "veneer.reference")
    ];

    const patternRefs = (_.get(configuration, "patterns", []) || []).map(pattern => pattern?.reference);
    const accessoryRefs = (_.get(configuration, "accessories", []) || []).map(accessory => accessory?.reference);

    return _.uniq(refs.concat(patternRefs, accessoryRefs).filter(Boolean));
  }

  getProject(currentConfig = null) {
    const storeCurrentConfig = _.get(getStore().getState(), "configurator.current", null);
    const scopedCurrent = currentConfig && currentConfig.configuration ? currentConfig : storeCurrentConfig;
    const configuration = _.get(scopedCurrent, "configuration", null);

    if (!configuration) return null;

    const type = this.getProjectType(configuration);
    const projectId = configuration.reference || scopedCurrent?.reference || configuration.quoteId || "";

    const granite_main = configuration.monument.graniteMain
    const granite_Secondary = configuration.monument.graniteSecondary
    return {
      id: projectId,
      name: _.get(configuration, "project.customer", ""),
      type,
      references: this.getProjectReferences(configuration),
      price_from: this.toDecimal(_.get(configuration, "price.selling")),
      buy_from: this.toDecimal(_.get(configuration, "price.discounted")),
      granit_main: granite_main || "",
      granit_secondary: granite_Secondary || "",
      status: this.getProjectStatus(configuration)
    };
  }
    
  // call to action button (configurator header)
  ctaOfConfiguration({ name, category, subcategory, type, from }, { template, subtemplate, currentPage = false }, aux = {}, ...except) {
    this.clearObjectExceptAgrs(...except, "user", "partner", "page");

    if (currentPage) {
      this.setCurrentPage({
        subtemplate: subtemplate || ""
      });
    }
    const pageState = this.getCurrentPage();
    const page = {
      page: {
        template: template ?? pageState.template,
        subtemplate: subtemplate ?? pageState.subtemplate
      }
    }

    const obj = {
      ...aux,
      event: "cta.click",
      cta: {
        name: name,
        category: category,
        subcategory: subcategory,
        type: type,
        from: from
      },
      user: this.getUser(),
      partner: {
        id: this.getPartner()
      },
      project: this.getProject()
    }
    let res = obj
    // set page obj from previews event if template == false && subtemplate == false
    if (template !== false && subtemplate !== false) {
      res = {
        ...obj,
        ...page
      }
    }
    this.push(res);
    
    // TagManager.dataLayer({ dataLayer: res })
  }

  closeModal() {
    // this.clearObjectExceptAgrs("partner", "user", "page");
    const obj = {
      user: this.getUser(),
      partner: {
        id: this.getPartner()
      },
      page: this.getCurrentPage(),
      project: this.getProject()
    }
    this.push(obj);
  }

  // on load
  loadConfiguration(config, categories, showBtnFlowers) {
    this.clearObjectExceptAgrs("products");
    const { granites, allgranites } = config.options
    const { name, productId, reference, category, graniteMain, graniteSecondary, monumentType } = config.configuration.monument
    // _________
    const granite_main = allgranites.find(g => g.reference === graniteMain)
    const granite_secondary = allgranites.find(g => g.reference === graniteSecondary)
    const category_obj = categories.find(c => c.categoryType === category)
    let monumentTypeValue = typeMonuments.find(t => t.type === monumentType)
    if (category === "ACC") {
      monumentTypeValue = "accessoire"
    } else if(category === "SEM") {
      monumentTypeValue = "semelle"
    } else if (category === "PLT") {
      monumentTypeValue = "placage"
    }
    // const { search } = getStore().getState().catalog
    // const category_obj = categories.find(c => search.category && c.filter === search.category)
    // ____ user _____
    const obj = {
      event: "product.page_display",
      page: {
        template: "configurateur",
        subtemplate: "produit"
      },
      product: {
        id: productId,
        name: name || "", // get name
        reference: reference,
        price_from: config.configuration.price.selling,
        buy_from: config.configuration.price.discounted,
        granits: [
          granite_main ? granite_main.name : "", 
          granite_secondary ? granite_secondary.name : ""
        ],
        styles: [category_obj ? category_obj.label : ""], // second filter <--
        couleurs: [granite_main ? granite_main.colorGranite : "", 
          granite_secondary ? granite_secondary.colorGranite : ""], // empty
        types: [monumentTypeValue], // empty main filter <--
        granit_main: granite_main ? granite_main.name : "",
        flower_button: showBtnFlowers,
        v360_button: true
      },
      partner: {
        id: this.getPartner()
      },
      user: this.getUser(),
      project: this.getProject(config)
    }
    this.push(obj);
  }

  listHeadstoone(config) {
    this.clearObjectExceptAgrs("products");
    const { headstones } = config
    
    const headstoneList = headstones.map(headstone => {
      return {
        reference: headstone.reference,
        name: headstone.name,
        featured: headstone.featured,
        suggested: headstone.suggested
      }
    })
    // ____ user _____
    const obj = {
      event: "product.list_display",
      page: {
        template: "configurateur",
        subtemplate: "produit - liste stèles"
      },
      headstones: headstoneList,
      partner: {
        id: this.getPartner()
      },
      user: this.getUser(),
      project: this.getProject()
    }
    this.push(obj);
  }

  // customizeConfigurator(event, subtemplate, {type, query, filter}, list = false, pattern = false) {
  //     this.clearObjectExceptAgrs("partner", "product", "user", "page");
  //     const pageState = this.getCurrentPage();
  //     let obj = {
  //       event: event,
  //       page: pageState,
  //       customize: {
  //         type: type,
  //         query: query,
  //         filter: filter
  //       },
  //       user: this.getUser()
  //     }
  //     if (list) {
  //       obj = {
  //         ...obj,
  //         list: list
  //       }
  //     }
  //     if (pattern) {
  //       obj = {
  //         ...obj,
  //         pattern: pattern
  //       }
  //     }
      
  //     TagManager.dataLayer({ dataLayer: obj })
  //   }

  listGranites(granites, filter={couleur: "", recherche: ""}, type = null) {
    this.clearObjectExceptAgrs("products");
    const subtemplate = GRANITE_LIST_SUBTEMPLATE_BY_TYPE[type] || 'produit - liste granits';
    // const { headstones } = config
    // const { name, productId, reference, category, graniteMain, graniteSecondary } = config.configuration.monument
    const graniteList = granites.map(g => {
      return {
        reference: g.reference,
        name: g.name,
        color: g.colorGranite,
        madeInFrance: g.madeInFrance
      }
    })
    // ____ user _____
    const obj = {
      event: "product.list_display",
      page: {
        template: "configurateur",
        subtemplate
      },
      filter: filter,
      granits: graniteList,
      partner: {
        id: this.getPartner()
      },
      user: this.getUser(),
      project: this.getProject()
    }
    this.push(obj);
  }

  clickGranite(granite, type = 'monument') {
    this.clearObjectExceptAgrs("partner", "user");
    const subtemplate = GRANITE_LIST_SUBTEMPLATE_BY_TYPE[type] || GRANITE_LIST_SUBTEMPLATE_BY_TYPE.monument;
    const graniteData = granite || {};

    const obj = {
      event: "product.click",
      page: {
        template: "configurateur",
        subtemplate
      },
      product: {
        reference: graniteData.reference || "",
        name: graniteData.name || "",
        color: graniteData.colorGranite || "",
        madeInFrance: graniteData.madeInFrance
      },
      partner: {
        id: this.getPartner()
      },
      user: this.getUser(),
      project: this.getProject()
    };

    this.push(obj);
  }

  listAccessories(accessories = []) {
    this.clearObjectExceptAgrs("partner", "user", "page");
    const accessoriesList = accessories.map((accessory) => ({
      reference: accessory.reference,
      name: accessory.name,
      description: accessory.description,
      kind: accessory.kind
    }));

    const obj = {
      event: "product.list_display",
      page: {
        template: "configurateur",
        subtemplate: "accessoires - liste accessoires"
      },
      accessories: accessoriesList,
      partner: {
        id: this.getPartner()
      },
      user: this.getUser(),
      project: this.getProject()
    };

    this.push(obj);
  }

  listFaces(faces = []) {
    this.clearObjectExceptAgrs("partner", "user", "page");
    const facesList = faces.filter(Boolean).map((face) => ({
      reference: face?.piece.reference,
      name: face?.piece.name,
      code: face?.piece.code
    }));
    const obj = {
      event: "product.list_display",
      page: {
        template: "configurateur",
        subtemplate: "motifs&gravures - autres pièces"
      },
      filter: {},
      faces: facesList,
      partner: {
        id: this.getPartner()
      },
      user: this.getUser(),
      project: this.getProject()
    };

    this.push(obj);
  }

  clickFace(faceData) {
    this.clearObjectExceptAgrs("partner", "user", "page", "product");
    const face = faceData?.piece || {};

    const obj = {
      event: "product.click",
      page: {
        template: "configurateur",
        subtemplate: "motifs&gravures - liste motifs"
      },
      product: {
        reference: face.reference || "",
        name: face.name || "",
        code: face.code || ""
      },
      partner: {
        id: this.getPartner()
      },
      user: this.getUser(),
      project: this.getProject()
    };

    this.push(obj);
  }

  listPatterns(patterns = [], query = "", keywords) {
    this.clearObjectExceptAgrs("partner", "user", "page");
    const patternsList = patterns.map((pattern) => ({
      reference: pattern.reference,
      name: pattern.name,
      kind: pattern.kind,
      imprint: pattern.imprint
    }));
    // filter
    const queryParts = Array.isArray(query)
      ? query.map(q => q?.trim()).filter(Boolean)
      : query?.split(",")?.map(q => q.trim()).filter(Boolean);

    const keywordMatches = [];
    const searchTerms = [];

    queryParts.forEach(part => {
      if (keywords.includes(part)) {
        keywordMatches.push(part);
      } else {
        searchTerms.push(part);
      }
    });

    const filter = {
      keywords: keywordMatches.join(","),
      recherche: searchTerms.join(",")
    };

    const obj = {
      event: "product.list_display",
      page: {
        template: "configurateur",
        subtemplate: "motifs&gravures - liste motifs"
      },
      filter: filter,
      motifs: patternsList,
      partner: {
        id: this.getPartner()
      },
      user: this.getUser(),
      project: this.getProject()
    };

    this.push(obj);
  }

  clickPattern(pattern) {
    this.clearObjectExceptAgrs("partner", "user", "page", "product");
    const patternData = pattern || {};

    const obj = {
      event: "product.click",
      page: {
        template: "configurateur",
        subtemplate: "motifs&gravures - liste motifs"
      },
      product: {
        reference: patternData.reference || "",
        name: patternData.name || "",
        kind: patternData.kind || "",
        imprint: patternData.imprint || ""
      },
      partner: {
        id: this.getPartner()
      },
      user: this.getUser(),
      project: this.getProject()
    };

    this.push(obj);
  }
  

  clickAccessory(accessory) {
    this.clearObjectExceptAgrs("partner", "user");
    const accessoryData = accessory || {};

    const obj = {
      event: "product.click",
      page: {
        template: "configurateur",
        subtemplate: "accessoires - liste accessoires"
      },
      product: {
        reference: accessoryData.reference || "",
        name: accessoryData.name || "",
        description: accessoryData.description || "",
        kind: accessoryData.kind || ""
      },
      partner: {
        id: this.getPartner()
      },
      user: this.getUser(),
      project: this.getProject()
    };

    this.push(obj);
  }

  clickHeadstone(headstone) {
    this.clearObjectExceptAgrs("partner", "user");
    const headstoneData = headstone || {};

    const obj = {
      event: "product.click",
      page: {
        template: "configurateur",
        subtemplate: "produit - liste stèles"
      },
      product: {
        reference: headstoneData.reference || "",
        name: headstoneData.name || "",
        featured: headstoneData.featured,
        suggested: headstoneData.suggested
      },
      partner: {
        id: this.getPartner()
      },
      user: this.getUser(),
      project: this.getProject()
    };

    this.push(obj);
  }

  // Clear the previous object
  clearObjectExceptAgrs(...args) {
    let obj = {
      page: null,
      partner: null,
      cta: null,
      product: null,
      user: null,
      project: null
    } 
    // Attributs to not reset
    args.map(arg => {
      delete obj[arg]
    })
    // Send data
    this.push(obj);
    // TagManager.dataLayer({ 
    //   dataLayer: obj
    // })
  }
}
export const gtmPro = () => GtmPro.getInstance();